export default __webpack_public_path__ + "static/media/book.3db3b3e5.png";